import { render, staticRenderFns } from "./NotificationAccountLowBalance.vue?vue&type=template&id=54bf87ed&scoped=true&lang=pug&"
import script from "./NotificationAccountLowBalance.vue?vue&type=script&lang=js&"
export * from "./NotificationAccountLowBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bf87ed",
  null
  
)

export default component.exports